/**
 * Single accessor for client-safe runtime config.
 * Do not expose process.env or config.public.env wholesale.
 */
export function useAppConfig() {
  const config = useRuntimeConfig()

  return {
    backendUrl: config.public.backendUrl,
    pdfKey: config.public.pdfKey,
    pusherAppKey: config.public.pusherAppKey,
    pusherCluster: config.public.pusherCluster,
    pusherWsHost: config.public.pusherWsHost,
    pusherWsPort: config.public.pusherWsPort,
    nodeEnv: config.public.nodeEnv,
    sentryDsn: config.public.sentryDsn,
  }
}
